import { useQuery } from "react-query";
import { QueryKeys } from "./query-client";
import { BACKEND_URL } from "../../constants/env";
import { CustomerNotification } from "../../constants/model/models";
import { useJWT } from "./useJWT";

export function useNotificationList() {
  const { jwt } = useJWT();

  async function getAttachmentList(): Promise<CustomerNotification[]> {
    if (jwt) {
      return fetchAttachments(jwt);
    } else {
      return [];
    }
  }

  async function fetchAttachments(authToken: string) {
    const url = `${BACKEND_URL}/user/profile/notifications`;

    const response = await fetch(url, {
      headers: {
        "Content-type": "application/json",
        accessToken: authToken,
      },
    });

    return await response.json();
  }

  const {
    data: notificationData,
    isFetching: notificationsAreLoading,
    isError: notificationListError,
  } = useQuery([QueryKeys.NOTIFICATIONS], () => getAttachmentList(), {
    keepPreviousData: true,
    enabled: jwt !== null && typeof jwt !== "undefined",
    retry: 2,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
  });

  return {
    notificationData,
    notificationsAreLoading,
    notificationListError,
  };
}
